"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _InputWrapper = _interopRequireDefault(require("../InputWrapper"));

var _Base = _interopRequireDefault(require("../Input/Base"));

var _Validate = require("../Validate");

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _Options = _interopRequireDefault(require("./Options"));

var _Item = _interopRequireDefault(require("./Item"));

var _Tag = _interopRequireDefault(require("./Tag"));

var _constants = require("../../constants");

require("./styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Dropdown =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "listRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var title = _ref.title,
          value = _ref.value,
          data = _ref.data;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          name = _this$props.name,
          disabled = _this$props.disabled;

      if (disabled) {
        return;
      }

      var newValue = value;

      if (multiple) {
        newValue = [];

        if (_this.state.value.map(function (d) {
          return d.value;
        }).indexOf(value) === -1) {
          // console.log('can add');
          newValue = _this.state.value.concat({
            title: title,
            value: value
          });
        } else {
          // console.log('already existed, remove');
          newValue = _this.state.value.filter(function (d) {
            return d.value !== value;
          });
        }
      }

      _this.setState({
        title: title,
        value: newValue,
        match: title
      }, function () {
        var onChange = _this.props.onChange;

        if (onChange) {
          onChange(e, {
            name: name,
            value: newValue,
            data: data
          });
        }

        if (!multiple) {
          _this.handleOnClose(e); // once select, close automatically for non multiple type

        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchOnChange", function (e, _ref2) {
      var value = _ref2.value;
      var _this$props2 = _this.props,
          searchable = _this$props2.searchable,
          disabled = _this$props2.disabled;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (searchable) {
        var searchFilter = _this.props.searchFilter; // force active to true to prevent options not showing when matched

        _this.setState({
          match: value,
          active: true
        }, function () {
          var options = _Options["default"].getOptions(_this.props);

          var filteredOptions = options.filter(function (item, idx, arr) {
            return searchFilter(value, item, idx, arr);
          });
          if (filteredOptions !== options) _this.setState({
            options: filteredOptions
          });
          if (!value) _this.setState({
            options: options
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchOnFocus", function () {
      return _this.setState({
        match: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToggle", function (e) {
      var active = _this.state.active;
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          onClick = _this$props3.onClick;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (!active) {
        _this.handleOnOpen(e);
      } else {
        _this.handleOnClose(e);
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      var multiple = _this.props.multiple;
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      _this.setState({
        active: true
      }, function () {
        if (!multiple) {
          // check scrollTop if not multiple dropdown
          _this.handleGetScrollTop();
        }

        document.addEventListener('click', _this.handleCheckClose);
        var onOpen = _this.props.onOpen;

        if (onOpen) {
          onOpen(e, _this.props);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');
      var title = _this.state.title;

      var options = _Options["default"].getOptions(_this.props);

      _this.setState({
        active: false,
        direction: null,
        // searchable reset
        match: title || '',
        options: options
      }, function () {
        document.removeEventListener('click', _this.handleCheckClose);
        var onClose = _this.props.onClose;

        if (onClose) {
          onClose(e, _this.props);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleGetScrollTop", function () {
      var value = _this.state.value;
      var options = _this.state.options;

      if (value && options) {
        var listNode = _this.listRef.current;

        if (listNode) {
          var index = options.findIndex(function (o) {
            return o.value === value;
          });

          if (index > -1) {
            var selectedOptionScrollTop = listNode.children[index].offsetTop;
            listNode.scrollTop += selectedOptionScrollTop;
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');
      var active = _this.state.active;

      if (active) {
        if (!e.target.classList.contains(_Item["default"].className)) {
          // if click on dropdown item, wont close, otherwise close
          _this.handleOnClose(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeleteSelected", function (e, _ref3) {
      var value = _ref3.value;
      var name = _this.props.name;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      var newValue = _this.state.value.filter(function (d) {
        return d.value !== value;
      });

      _this.setState({
        value: newValue
      }, function () {
        var onChange = _this.props.onChange;

        if (onChange) {
          onChange(e, {
            name: name,
            value: newValue
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var selectedData = _this.state.selectedData;
      var propNames = ['disabled', 'fluid', 'multiple'];
      var names = [Dropdown.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropName)(names, _this.state, ['active']);

      if ((0, _lib.arrayHasItems)(selectedData)) {
        // TODO: add this class if has changes
        (0, _lib.addClassName)(names, 'selected');
      }

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function (value) {
      var multiple = _this.props.multiple;

      if (multiple) {
        return _this.state.value.some(function (v) {
          return v.value === value;
        });
      }

      return _this.state.value === value;
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlaceholders", function () {
      var _this$props4 = _this.props,
          multiple = _this$props4.multiple,
          placeholder = _this$props4.placeholder,
          color = _this$props4.color,
          disabled = _this$props4.disabled;
      var _this$state = _this.state,
          value = _this$state.value,
          title = _this$state.title;

      if (multiple) {
        return (0, _lib.arrayHasItems)(value) ? value.map(function (data) {
          return _react["default"].createElement(_Tag["default"], {
            color: color,
            disabled: disabled,
            key: data.value,
            value: data.value,
            title: data.title,
            onDelete: function onDelete(e) {
              return _this.handleDeleteSelected(e, data);
            }
          });
        }) : placeholder;
      }

      return title || placeholder;
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props5 = _this.props,
          disabled = _this$props5.disabled,
          children = _this$props5.children,
          withPortal = _this$props5.withPortal,
          direction = _this$props5.direction,
          emptyNode = _this$props5.emptyNode;
      var _this$state2 = _this.state,
          active = _this$state2.active,
          options = _this$state2.options;
      return _react["default"].createElement(_Options["default"], {
        parent: _this.innerRef.current,
        direction: direction,
        withPortal: withPortal,
        innerRef: _this.listRef,
        visible: active,
        options: options,
        disabled: disabled,
        onChange: _this.handleOnChange,
        isItemSelected: _this.handleItemSelected,
        emptyNode: emptyNode
      }, children);
    });

    var _value = props.value,
        defaultValue = props.defaultValue,
        _multiple = props.multiple,
        _options = props.options;

    var _newValue = _value || defaultValue;

    var newOptions = _Options["default"].getOptions(props);

    var _title;

    if (newOptions || _newValue || _newValue === undefined) {
      if (_multiple) {
        if ((0, _lib.arrayHasItems)(_newValue)) {
          _newValue = _newValue.filter(function (_ref4) {
            var v = _ref4.value;
            return newOptions.some(function (o) {
              return v === o.value;
            });
          });
        } else {
          _newValue = [];
        }
      } else {
        var index = newOptions.findIndex(function (o) {
          return o.value === _newValue;
        });

        if (index > -1) {
          _title = newOptions[index].title;
        } else {
          _title = undefined;
          _newValue = undefined;
        }
      }
    }

    _this.state = {
      prevProps: {
        value: _value,
        options: _options
      },
      value: _newValue || (_multiple ? [] : undefined),
      options: newOptions,
      title: _title,
      match: _title || '',
      active: false,
      direction: null
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props6 = this.props,
          name = _this$props6.name,
          options = _this$props6.options,
          updateOnChange = _this$props6.updateOnChange;
      var value = this.state.value;

      if (updateOnChange && prevProps.options !== options && prevState.value !== value) {
        // if options changed and value does not exist in new options,
        // have to call onChange in componentDidUpdate
        var onChange = this.props.onChange;

        if (onChange) {
          // FIXME: data is not passed here
          onChange(null, {
            name: name,
            value: value
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          children = _this$props7.children,
          name = _this$props7.name,
          options = _this$props7.options,
          placeholder = _this$props7.placeholder,
          multiple = _this$props7.multiple,
          withArrow = _this$props7.withArrow,
          onClick = _this$props7.onClick,
          onOpen = _this$props7.onOpen,
          onClose = _this$props7.onClose,
          onChange = _this$props7.onChange,
          disabled = _this$props7.disabled,
          readOnly = _this$props7.readOnly,
          updateOnChange = _this$props7.updateOnChange,
          withPortal = _this$props7.withPortal,
          direction = _this$props7.direction,
          searchFilter = _this$props7.searchFilter,
          searchable = _this$props7.searchable,
          emptyNode = _this$props7.emptyNode,
          rest = _objectWithoutProperties(_this$props7, ["children", "name", "options", "placeholder", "multiple", "withArrow", "onClick", "onOpen", "onClose", "onChange", "disabled", "readOnly", "updateOnChange", "withPortal", "direction", "searchFilter", "searchable", "emptyNode"]);

      var _this$state3 = this.state,
          active = _this$state3.active,
          match = _this$state3.match,
          title = _this$state3.title;
      var classNames = this.classNames();
      return _react["default"].createElement(_InputWrapper["default"], _extends({}, rest, {
        wrapperRef: this.innerRef,
        className: classNames,
        onClick: !readOnly ? this.handleOnToggle : null,
        suffix: !readOnly && withArrow ? _react["default"].createElement(_Arrow["default"], {
          active: active,
          disabled: disabled
        }) : null
      }), searchable ? _react["default"].createElement(_Base["default"], {
        placeholder: title || placeholder,
        disabled: disabled,
        readOnly: readOnly,
        value: match,
        onFocus: this.handleSearchOnFocus,
        onChange: this.handleSearchOnChange
      }) : _react["default"].createElement("div", {
        className: "MHub-Dropdown-Placeholder"
      }, this.renderPlaceholders()), this.renderOptions());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          options = props.options,
          multiple = props.multiple;

      var newOptions = _Options["default"].getOptions(props);

      var title = state.title;
      var newValue = prevProps.value !== value ? value : state.value;

      if (newOptions || newValue || newValue === undefined) {
        if (multiple) {
          if ((0, _lib.arrayHasItems)(newValue)) {
            newValue = newValue.filter(function (_ref5) {
              var v = _ref5.value;
              return newOptions.some(function (o) {
                return v === o.value;
              });
            });
          } else {
            newValue = [];
          }
        } else {
          var index = newOptions.findIndex(function (o) {
            return o.value === newValue;
          });

          if (index > -1) {
            title = newOptions[index].title;
          } else {
            title = undefined;
            newValue = undefined;
          }
        }
      }

      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          options: options
        },
        value: newValue,
        options: prevProps.options !== options ? newOptions : state.options,
        title: title,
        match: prevProps.value !== value ? title || '' : state.match
      };
    }
  }]);

  return Dropdown;
}(_react.PureComponent);

exports["default"] = Dropdown;

_defineProperty(Dropdown, "Validate", (0, _Validate.withValidate)(Dropdown));

_defineProperty(Dropdown, "Arrow", _Arrow["default"]);

_defineProperty(Dropdown, "Options", _Options["default"]);

_defineProperty(Dropdown, "Item", _Item["default"]);

_defineProperty(Dropdown, "Tag", _Tag["default"]);

_defineProperty(Dropdown, "className", 'MHub-Dropdown');

_defineProperty(Dropdown, "displayName", 'Dropdown');

_defineProperty(Dropdown, "propTypes", {
  children: _propTypes["default"].node,
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_common.customPropTypes.stringOrNumber.isRequired, _propTypes["default"].arrayOf(_common.customPropTypes.stringOrNumber)]),
  defaultValue: _propTypes["default"].oneOfType([_common.customPropTypes.stringOrNumber.isRequired, _propTypes["default"].arrayOf(_common.customPropTypes.stringOrNumber)]),
  options: _common.customPropTypes.dropdownOption,
  placeholder: _propTypes["default"].string,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  withArrow: _propTypes["default"].bool,
  updateOnChange: _propTypes["default"].bool,
  withPortal: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['auto'])), _propTypes["default"].arrayOf(_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['autoV', 'autoH'])))]),
  searchable: _propTypes["default"].bool,
  searchFilter: _propTypes["default"].func,
  emptyNode: _propTypes["default"].node,
  color: _propTypes["default"].oneOf(['blue', 'red'])
});

_defineProperty(Dropdown, "defaultProps", {
  children: null,
  name: null,
  value: undefined,
  defaultValue: undefined,
  options: [],
  placeholder: 'Select',
  onOpen: null,
  onClose: null,
  onChange: null,
  onClick: null,
  readOnly: false,
  disabled: false,
  multiple: false,
  withArrow: true,
  updateOnChange: true,
  withPortal: false,
  direction: 'auto',
  searchable: false,
  searchFilter: function searchFilter(match, _ref6) {
    var title = _ref6.title;
    return title.toLowerCase().includes(match.toLowerCase());
  },
  emptyNode: _react["default"].createElement(_Item["default"], null, "No result found."),
  color: null
});